/**
 * Draft message for contact form when user taps "Apply for installment" on a product.
 * @param {{ productName: string, modelNumber?: string, sku?: string }} inquiry
 */
export function composeInstallmentInquiryDraft(inquiry) {
    const name = (inquiry.productName || '').trim() || 'this product';
    const model = (inquiry.modelNumber || '').trim();
    const sku = (inquiry.sku || '').trim();

    let text = `I want to buy ${name} on installment.\n\n`;
    if (model) {
        text += `Model is ${model}.\n\n`;
    }
    if (!model && sku) {
        text += `SKU (reference): ${sku}.\n\n`;
    } else if (sku) {
        text += `SKU: ${sku}\n\n`;
    }
    return `${text.trimEnd()}\n\n`;
}
